import { render } from "./ord-empty.vue?vue&type=template&id=73ed6ee0"
import script from "./ord-empty.vue?vue&type=script&lang=js"
export * from "./ord-empty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__